import { mapToBreakpoints, spacing } from '@koaly/mixins';

const getSpacingAfter = (values, negative) => {
    return mapToBreakpoints(values, (value) => {
        if (!negative) {
            return `margin-bottom: ${spacing(value)}`;
        }
        else {
            return `margin-bottom: -${spacing(value)}`;
        }
    });
};

export { getSpacingAfter };
//# sourceMappingURL=getSpacingAfter.js.map
